<template>
    <div v-if="shipping==14">
        <p class="alert alert-warning text-center">
            {{ $translate("Woerner::Template.AngebotBerechnung") }}
        </p>
        <div class="widget-success">

            <button id="button_angebot" class="btn btn-primary btn-block" @click="doPlaceAngebot()" :disabled="loading">
                {{ $translate("Woerner::Template.AngebotCheckout") }}
                <icon icon="arrow-right" :loading="loading"></icon>
            </button>
        </div>
    </div>
</template>

<script>
    import TranslationService from "../services/TranslationService";
    import {mapActions} from "vuex";
    export default
    {
        props:
        {
            template:
            {
                type: String,
                default: "#vue-angebot-spedition"
            },
        },
        data: function()
        {
            return {
                shippingProfileId:0,
                loading:false
            }
        },
        created()
        {
            this.getShipping();
        },
        methods:
        {
            getShipping()
            {
                if(this.$store.state.basket.data.shippingProfileId== 14)
                {
                    $('.widget-place-order').addClass('d-none');
                }
                else
                {
                    $('.widget-place-order').addClass('d-block');
                }
                return this.$store.state.basket.data.shippingProfileId
            },
            doPlaceAngebot ()
            {
                let _self = this;
                _self.loading = true;

                if (ceresStore.state.user.userData == null)
                {
                    this.loadComponent("login-modal");
                    $('#login-modal-wrapper .login-modal').modal('show');
                    CeresNotification.error(TranslationService.translate("Woerner::Template.plsLoginAngebot"));
                    _self.loading = false;
                }
                else if (ceresStore.state.address.billingAddressId)
                {
                    let data =
                        {
                            "contactWish": ceresStore.state.checkout.contactWish,
                            "customerSign": ceresStore.state.checkout.customerSign,
                            "contactId": ceresStore.state.user.userData.id,
                            "items": ceresStore.state.basket.items,
                            "billingId": ceresStore.state.address.billingAddressId,
                            "deliveryId": ceresStore.state.address.deliveryAddressId,
                            "locationId": ceresStore.state.localization.shippingCountryId,
                            "basket": ceresStore.state.basket.data
                        }
                    // Save Angebot

                    $.ajax(
                        {
                            type: 'POST',
                            url: '/order/angebot/'+App.language+'/',
                            data: data,
                            dataType: 'json',
                            success: function (data)
                            {
                                if (data) {
                                    $.ajax(
                                        {
                                            type: 'POST',
                                            url: '/cartsave/basket/delete/',
                                            success: function (response) {
                                                // Redirect to Angebot page
                                                window.location.href = App.urls.myAccount;
                                            },
                                            error: function (jqXHR) {
                                                // console.log(jqXHR);
                                            }
                                        });
                                }
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                // console.error(errorThrown);
                            }
                        });

                }
                else
                {
                    CeresNotification.error(TranslationService.translate("Woerner::Template.noAddress"));
                    _self.loading = false;
                }
            },

            ...mapActions([
                "loadComponent"
            ])

        },

        computed:
        {
            shipping:function()
            {
                return this.getShipping();
            }
        }
    }
</script>
